import type { PurchaseGraph } from "../domain/purchase";
import { computePurchase,distributeProportionally } from "./purchaseMath";

/** Explicit company imports distribute shipping over the whole source,
 * including the business remainder. Legacy purchases retain their rules. */
export function companyReceiptShippingOverrides(graph:PurchaseGraph):{id:string;shippingCents:number}[]{
  const calculation=computePurchase(graph);
  const weights=[...graph.allocations.map(a=>a.amountCents),calculation.unallocatedCents];
  const shares=distributeProportionally(graph.purchase.shippingCents,weights);
  return graph.allocations.map((a,i)=>({id:a.id,shippingCents:shares[i]}));
}
